import { useContext, useEffect, useState } from "react"
import API from "./API"
import { Link, useNavigate, useParams } from "react-router"
import { useForm } from "react-hook-form"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ModalContext } from './ModalContext';
import ApiResult from './ApiResult';
import { AdminQueryActivity, AdminQueryUsage } from "../../backend/src/api/dto"
import DisplayUsage from "./components/DisplayUsage"
import ModalConfirmation from "./Modal/Confirmation"

type FormValues = {
    name: string
    description: string
    status: boolean
}


function Activity() {

    const params = useParams();
    let navigate = useNavigate();

    const [data, setData] = useState<{
        activity: AdminQueryActivity,
        usage: AdminQueryUsage[],
    }>({
        activity: {
            activityId: 0,
            name: '',
            description: '',
            status: false
        }, usage: []
    })
    const [apiResult, setApiResult] = useState<null | { status: boolean, message?: string[] }>(null)
    const [showModal, closeModal] = useContext(ModalContext);

    const [loading, setLoading] = useState(true)
    const { register, control, getValues } = useForm<FormValues>({
        defaultValues: async () => {
            if (params.activityId !== "0") {
                const activity = await API.getActivity(params.activityId ?? 0)
                setData(prevData => {
                    return {
                        ...prevData,
                        ...activity
                    }
                })
                setLoading(false)
                return activity.activity
            } else {
                setLoading(false)
                return {
                    status: true,
                    name: '',
                    description: ''
                }
            }

        }
    })

    const reloadData = (): Promise<any> => {
        setLoading(true)
        return API.getActivity(params.activityId ?? 0).then(activity => {
            setData(prevData => {
                return {
                    ...prevData,
                    ...activity,

                }
            })
            setLoading(false)
        }).catch(e => {
            setLoading(false)
        })
    }



    useEffect(() => {
        if (params.activityId !== "0") {
            reloadData()
        }
    }, [params.activityId])

    const addActivity = () => {
        API.addActivity(getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/activity')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const saveActivity = () => {
        API.saveActivity(params.activityId ?? 0, getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/activity')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }


    const deleteActivity = () => {
        return API.deleteActivity(params.activityId ?? 0).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/activity')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }



    if (loading) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>
                        <div className="mt-2">Aktivita: ...</div>
                    </div>
                    <div className="card-body">
                        Nahrávam
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header " style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-1">
                            <span className=""><Link to="/dashboard/activity" className="btn btn-primary"><FontAwesomeIcon fixedWidth icon={["fas", "arrow-left"]} /> Späť</Link></span>
                        </div>
                        <div className="col-6">
                            <div className="mt-2">Aktivita: <strong>{
                                params.activityId === "0" ? '[ Vytvoriť novú ]' : getValues().name
                            }</strong></div>
                        </div>
                        <div className="col-5 text-end">
                            {
                                params.activityId === "0" ?
                                    <button className="btn btn-primary" onClick={addActivity}><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} />  Pridať aktivitu</button>
                                    :
                                    <>
                                        {
                                            !loading && !data.usage.length ?
                                                <button className="btn btn-danger me-3" onClick={() => showModal(
                                                    <ModalConfirmation
                                                        confirm={deleteActivity}
                                                        title={"Naozaj zmazať aktivitu?"}
                                                        text="" />
                                                )}><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} />  Zmazať aktivitu</button>
                                                : null

                                        }
                                        <button className="btn btn-primary" onClick={saveActivity}><FontAwesomeIcon fixedWidth icon={["fas", "floppy-disk"]} />  Uložiť aktivitu</button>
                                    </>

                            }
                        </div>
                    </div>
                </div>
                <div className="card-body">

                    <ApiResult errorObject={apiResult} />

                    <div className="row">
                        <div className="col-4">

                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Názov aktivity</label>
                                </div>
                                <div className="col-auto">
                                    <input type="text" {...register("name")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Popis</label>
                                </div>
                                <div className="col-8">
                                    <textarea rows={6} {...register("description")} className="form-control form-control-sm" />
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-4  mt-1 text-end">
                                    <label className="form-label">Aktívna</label>
                                </div>
                                <div className="col-8  mt-1">
                                    <div className="form-check">

                                        <input className="form-check-input" {...register("status")} type="checkbox" />
                                        <label className="form-check-label">

                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="offset-4 col-4">
                            {
                                params.activityId !== "0" ?
                                    <>
                                        <h4>Odkazy na túto aktivitu</h4>
                                        <DisplayUsage data={data.usage} />
                                        <div className="text-end">Zobrazuje sa maximále 100 záznamov</div>
                                    </>
                                    : null
                            }
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Activity